export default __webpack_public_path__ + "svg/calendar/2026/3/junio.svg?a501192b";